import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { getEmptyUser, User } from 'src/app/interfaces/user';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html',
  styleUrls: ['./userlist.component.scss'],
})
export class UserlistComponent implements OnInit {
  users: User[] = [];
  company: any;
  currentUserId: any;
  token: any;
  loading: boolean = false;
  companyid: any;
  userrole: any;
  constructor(
    private userService: UserService,
    private storage: Storage,
    private alertController: AlertController,
    private toastS: ToastService,
    private authService: AuthService,
    private compService: CompanyService
  ) {
    // if (this.company._id) {
    this.userService.userSave.subscribe(x => {
      this.foundIndex(x);
      // this.addNewUser();
    });
    // }
  }

  async ngOnInit() {
    this.token = await this.authService.getDecodedUserToken();
    this.company = await this.compService.getCompanyById(this.token.company).toPromise();
    if (this.token.company) {
      this.loading = true;
      this.userService.getUsersByCompanyId(this.token.company).subscribe(x => {
        this.users = x;
        this.users.forEach(user => {
          user.role = this.checkRole(user.role);
        });
        this.userSortName(this.users);
        console.log('USERS', this.users);
        this.loading = false;
        // this.addNewUser();
      })
    }
  }

  ionViewWillEnter() {
  }

  foundIndex(user: any) {
    // bekommt entweder -1 wenn kein index gefunden wird oder index
    let emptyElementIndex = this.users.findIndex(index => index._id === undefined)
    if (emptyElementIndex > -1) {
      this.users.splice(emptyElementIndex, 1);
    }
    let index = this.users.findIndex(x => x._id === (user as User)._id);
    this.currentUserId = user._id;
    if (index != -1) {
      this.users[index] = user;
    } else {
      this.users.unshift(user);
    }
  }

  edit(user) {
    console.log('AUSGEWÄHLTER USER:', user)
    this.foundIndex(user);
    this.userService.userDataSubject.next(user);
  }

  addNewUser() {
    let userEmpty = getEmptyUser();
    userEmpty.company = this.token.company;
    this.foundIndex(userEmpty);
    this.userService.userDataSubject.next(userEmpty);
  }

  sortByDateAsc(array) {

  }

  userSortName(array) {
    array.sort((a, b) => {
      if (a.fullname > b.fullname) {
        return 1
      }
      if (a.fullname < b.fullname) {
        return -1
      }
      else {
        return 0
      }
    });
  }

  async delete(user, index) {
    const alert = await this.alertController.create({
      header: 'LÖSCHEN',
      message: 'Möchtest du wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel'
        },
        {
          text: 'OK',
          role: 'ok',
          handler: () => {
            if (user.email != this.token.email) {
              this.userService.deleteUser2(user).subscribe(x => {
                console.log("Löschen funktioniert", x);
                // TODO: Toastmessage einbauen
                // local löschen
                this.users.splice(index, 1);
                this.toastS.deleteToast();
              }, err => {
                console.log("Löschen funktioniert NICHT", err);
                this.toastS.deleteToastNot();
              })
            } else {
              this.toastS.CurrentEmail();
            }
          }
        }
      ]
    });
    alert.present();
  }

  checkRole(role) {
    switch (role) {
      case 'COMPANY_ADMIN':
        return 'Admin'
      case 'EMPLOYEE':
        return 'Benutzer'
        break;
      default:
        break;
    }
  }
}
